import { defaultConfig, defineTokens } from '@chakra-ui/react';

const colors = defineTokens.colors({
    ...defaultConfig.theme?.tokens?.colors,
    light: {
        value: '#ffffff',
    },
    dark: {
        value: '#151515',
    },
    gray: {
        25: { value: '#fcfcfd' },
        50: { value: '#f9fafa' },
        100: { value: '#f4f5f6' },
        200: { value: '#ecedef' },
        300: { value: '#d3d5d9' },
        400: { value: '#9fa3ad' },
        500: { value: '#6C727F' },
        600: { value: '#50545E' },
        700: { value: '#3F434A' },
        800: { value: '#282A2F' },
        900: { value: '#1A1B1E' },
        950: { value: '#0f1012' },
    },
    indigo: {
        25: { value: '#fafaff' },
        50: { value: '#f5f5ff' },
        100: { value: '#ebecff' },
        200: { value: '#d7d9fe' },
        300: { value: '#bcbffb' },
        400: { value: '#9297f6' },
        500: { value: '#545cf8' },
        600: { value: '#555bd8' },
        700: { value: '#4349c7' },
        800: { value: '#383d9f' },
        900: { value: '#30347e' },
        950: { value: '#1a1d4f' },
    },
    purple: {
        25: { value: '#fdfbfd' },
        50: { value: '#f9f5fa' },
        100: { value: '#f2eaf5' },
        200: { value: '#e6d5eb' },
        300: { value: '#d1b3db' },
        400: { value: '#a971bc' },
        500: { value: '#904ea6' },
        600: { value: '#723e84' },
        700: { value: '#633672' },
        800: { value: '#4b2957' },
        900: { value: '#1e1023' },
        950: { value: '#271530' },
    },
    red: {
        25: { value: '#fffafb' },
        50: { value: '#fef1f2' },
        100: { value: '#fee1e4' },
        200: { value: '#fec7cd' },
        300: { value: '#fd9ba5' },
        400: { value: '#f96675' },
        500: { value: '#f0384a' },
        600: { value: '#d92033' },
        700: { value: '#b41828' },
        800: { value: '#911824' },
        900: { value: '#7a1a23' },
        950: { value: '#4c0f14' },
    },
    yellow: {
        25: { value: '#fffcf5' },
        50: { value: '#fffaeb' },
        100: { value: '#FEF0C7' },
        200: { value: '#fedf89' },
        300: { value: '#fec84b' },
        400: { value: '#fdb022' },
        500: { value: '#f79009' },
        600: { value: '#D75509' },
        700: { value: '#b54708' },
        800: { value: '#93370d' },
        900: { value: '#7a2e0e' },
        950: { value: '#4a1504' },
    },
    green: {
        25: { value: '#f6fefb' },
        50: { value: '#ecfdf6' },
        100: { value: '#d1faea' },
        200: { value: '#a4f4d4' },
        300: { value: '#6de9b7' },
        400: { value: '#34d595' },
        500: { value: '#17ba7c' },
        600: { value: '#03965b' },
        700: { value: '#027849' },
        800: { value: '#05603c' },
        900: { value: '#054d30' },
        950: { value: '#022f1d' },
    },
});

export { colors };
